import * as React from 'react';
import { useHistory } from 'react-router';
import { UserRoles } from '@bb/users';

import { Popconfirm, Menu, MenuItem } from 'components';

const AGENT_TITLE =
  'Are you sure you’d like to remove this user from the team?';
const TEAM_ADMIN_TITLE =
  'Are you sure you’d like to remove the Team Admin from this team? If yes, you will need to select a new team for this user or modify their role.';

export interface TeamMemberRemovalConfirmationProps {
  userId: string;
  userRole: UserRoles;
  visible: boolean;
  handleCancel: () => void;
  handleRemove: () => void;
}

const TeamMemberRemovalConfirmation: React.FC<
  TeamMemberRemovalConfirmationProps
> = ({ children, userId, userRole, visible, handleCancel, handleRemove }) => {
  const history = useHistory();

  const isTeamAdmin = userRole === UserRoles['Team Admin'];

  const handleConfirm = async () => {
    if (isTeamAdmin) {
      history.push(`/users/edit/${userId}`);
      return;
    }

    handleRemove();
  };

  // unmount popconfirm from the DOM when not visible
  return visible ? (
    <Popconfirm
      title={isTeamAdmin ? TEAM_ADMIN_TITLE : AGENT_TITLE}
      maxWidth="min(85vw, 350px)"
      open={visible}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
      okText=">  Yes"
      cancelText="> No"
      placement="topRight"
    >
      {children}
    </Popconfirm>
  ) : (
    <>{children}</>
  );
};

export default TeamMemberRemovalConfirmation;
